// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.fermentation_status_enum */
var FermentationStatusEnum;
(function (FermentationStatusEnum) {
    FermentationStatusEnum["PLANNED"] = "PLANNED";
    FermentationStatusEnum["PREPARING"] = "PREPARING";
    FermentationStatusEnum["PREPARED"] = "PREPARED";
    FermentationStatusEnum["RUNNING"] = "RUNNING";
    FermentationStatusEnum["ENDED"] = "ENDED";
    FermentationStatusEnum["ARCHIVED"] = "ARCHIVED";
})(FermentationStatusEnum || (FermentationStatusEnum = {}));
;
export default FermentationStatusEnum;
/** Zod schema for fermentation_status_enum */
export const fermentationStatusEnum = z.nativeEnum(FermentationStatusEnum);
//# sourceMappingURL=FermentationStatusEnum.js.map